import Papa from "papaparse";

const UTF8_BOM = "\uFEFF";
const SEP_HINT = "sep=;\n";

type Column = { key: string; header: string };

export const toCsv = (
  columns: Column[],
  rows: Record<string, unknown>[]
): string => {
  const data = rows.map((row) =>
    columns.map((c) => (row[c.key] ?? "") as unknown)
  );
  const body = Papa.unparse(
    { fields: columns.map((c) => c.header), data },
    { delimiter: ";", newline: "\n", quotes: false }
  );
  return UTF8_BOM + SEP_HINT + body;
};

export const parseCsv = (
  content: string
): { headers: string[]; rows: string[][] } => {
  let text = content;
  if (text.charCodeAt(0) === 0xfeff) text = text.slice(1);
  if (text.toLowerCase().startsWith("sep=")) {
    const nl = text.indexOf("\n");
    text = nl >= 0 ? text.slice(nl + 1) : "";
  }
  const result = Papa.parse<string[]>(text, {
    skipEmptyLines: true,
    delimiter: "",
  });
  const all = result.data.map((r) => r.map((c) => (c ?? "").trim()));
  if (all.length === 0) return { headers: [], rows: [] };
  return { headers: all[0], rows: all.slice(1) };
};
